"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeDuplicatePrimitives;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
function removeDuplicatePrimitives(arr) {
  if (!Array.isArray(arr)) {
    return null;
  }
  return (0, _toConsumableArray2.default)(new Set(arr));
}